/*
 * @Date: 2023-11-12 23:34:48
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:53:05
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/message.js
 * @Description: 語音房發送的消息類型
 */
import i18n from '@/locales/index'

const emojiResource = [
  {
    name: i18n.t('components_voiceroom_message_1925'),
    imageNameList: ['emoji_jiandao.webp', 'emoji_shitou.webp', 'emoji_bu.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1926'),
    imageNameList: ['emoji_handup.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1927'),
    imageNameList: ['emoji_light.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1928'),
    imageNameList: ['emoji_thank.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1929'),
    imageNameList: ['emoji_gift.webp']
  },
  {
    name: 'OK',
    imageNameList: ['emoji_ok.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1930'),
    imageNameList: ['emoji_haha.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1931'),
    imageNameList: ['emoji_kiss.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1932'),
    imageNameList: ['emoji_cry.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1933'),
    imageNameList: ['emoji_laughcry.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1934'),
    imageNameList: ['emoji_....webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1935'),
    imageNameList: ['emoji_?.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1936'),
    imageNameList: ['emoji_comfortable.webp']
  },
  {
    name: i18n.t('components_voiceroom_message_1937'),
    imageNameList: ['emoji_cheer.webp']
  }
];
//文字類型消息
export class TextMessage {
  data = {
    version: '1',
    action: '301',
    command: {
      action: 'normal',
      level: '',
      nickName: ''
    },
    message: ''
  };
  description = '';
  extension = '';
  constructor(text, level, nickName) {
    this.data.message = text;
    this.data.command.level = level;
    this.data.command.nickName = nickName;
  }
}
/**
 * @description: 图片类型消息
 * @return {*}
 */
export class EmojiMessage {
  data = {
    version: '1',
    action: '301',
    command: 'emojiReceive',
    message: {
      imageUrlList: [],
      seatIndex: 0,
      avatar: '',
      uuid: '',
      nickName: '',
      level: '',
      animationUrlList: [],
      name: ''
    }
  };
  description = '';
  extension = '';

  constructor(uuid, nickName, avatar, emojiName, seatIndex) {
    console.log(uuid, nickName, avatar, emojiName, seatIndex);
    const emojiItem = emojiResource.find(item => {
      return item.name === emojiName;
    });
    let emojiList = emojiItem.imageNameList;
    if (emojiItem.name === i18n.t('components_voiceroom_message_1925')) {
      emojiList = shuffleArray([...emojiItem.imageNameList]);
    }
    this.data.message.uuid = uuid;
    this.data.message.nickName = nickName;
    this.data.message.avatar = avatar;
    this.data.message.animationUrlList = emojiList;
    this.data.message.imageUrlList = emojiList;
    this.data.message.seatIndex = seatIndex;
    this.data.message.name = emojiName;
    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
  }
}

export class ImageMessage {
  data = {
    version: '1',
    action: '301',
    message: {
      level: '',
      nickname: '',
      content: '',
      avatar: '',
      uuid: ''
    },
    command: 'imageReceive'
  };
  description = '';
  extension = '';
  constructor(uuid, url, level, nickName, avatar) {
    this.data.message.uuid = uuid;
    this.data.message.content = url;
    this.data.message.level = level;
    this.data.message.nickname = nickName;
    this.data.message.avatar = avatar;
  }
}
